import { Box, Grid, Typography } from "@mui/material";
import { ProfileProductCard } from "../product/ProfileProductCard";
import { ResultsWithFilter } from "../product/ResultsWithFilter";

import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ContactPageOutlinedIcon from "@mui/icons-material/ContactPageOutlined";

interface ISoldProps {}

export const Sold: React.FC<ISoldProps> = ({}) => {
  // dummy handlers
  const handleContactBuyer = (id: number) => {
    console.log("Contact buyer for product:", id);
  };

  const handleAddTracking = (id: number) => {
    console.log("Add tracking for product:", id);
  };

  const handleViewItem = (id: number) => {
    console.log("View sold item:", id);
  };

  const handleViewBuyerDetails = (id: number) => {
    console.log("View buyer details for product:", id);
  };

  return (
    <Box>
      <Grid container justifyContent="space-between" alignItems="center" pb={2}>
        <Grid item>
          <Typography variant="h6" fontWeight="bold">
            Items I've Sold
          </Typography>
        </Grid>
        <Grid item>
          <Grid container alignItems="center" spacing={1} wrap="nowrap">
            <ResultsWithFilter
              menuItems={[
                { label: "Filter by:", value: "", isDisabled: true },
                { label: "Recent", value: "Recent" },
                { label: "Oldest", value: "Oldest" },
              ]}
              filterHandler={() => {}}
              defaultValue="Recent"
              totalResults={0}
            />
          </Grid>
        </Grid>
      </Grid>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
        sx={{ color: "text.secondary" }}
      >
        <Typography variant="h6" textAlign="center">
          You haven't sold any items yet.
        </Typography>
      </Box>
    </Box>
  );
};
